import { render, staticRenderFns } from "./PersonExtraWorkListMobItem.vue?vue&type=template&id=fec8aae6&scoped=true&"
import script from "./PersonExtraWorkListMobItem.vue?vue&type=script&lang=js&"
export * from "./PersonExtraWorkListMobItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonExtraWorkListMobItem.vue?vue&type=style&index=0&id=fec8aae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec8aae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VExpandTransition,VIcon,VRow})
